import Rete from "rete";
import AnyTypeSocket,{ ArraySocket } from "../../../Utils/CommonSockets.js";
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { DateTimeSocket } from "../../../Utils/CommonSockets.js";
import { NumberControl, NumberSocket } from "../../rete-controls/NumberControl.js";
import { EventBus } from '../../../event-bus.js';

export default class AUntilBTriggerComponent extends Rete.Component {
  constructor() {
    super("A-Until-B"); // name
    this._categories = ["Conditionals","Simulator"];

    this._nodeStateData = {};
    this._eventRegistered = false;
    EventBus.$on('global-reset-nodes', x => {
      this.doResetNode(true,"all");
  });
  
  }

  buildNodeData(node) {
    if (node !== null && node !== undefined && node.id != undefined) {
      this._nodeStateData[node.id] = {
        ASet : null,
        BSet : null,
        lastReset: null,
        count : 1,

        reset(resetCount) {
          this.ASet = null;
          this.BSet = null;
          this.lastReset = null;
          if(resetCount) this.count = 1;
        }
      };
    }
  }
  registerOnRemove() {
    if (!this._eventRegistered) {
      var data = this._nodeStateData;
      this.editor.on("noderemoved", nodex => {
        console.log("removing " + nodex.id);

        if (data[nodex.id] !== null && data[nodex.id] !== undefined) {
          console.log("data gone " + nodex.id);

          delete data[nodex.id];
        }
      });
    }
    this._eventRegistered = true;
  }


  builder(node) {
    var inp1 = new Rete.Input("in1", "A", AnyTypeSocket);
    var inp2 = new Rete.Input("in2", "B", AnyTypeSocket);
    var inp3 = new Rete.Input('resetIn','Reset',ResetSocket);

    var inp4 = new Rete.Input("in3", "If A.length >=", NumberSocket);

    let out1 = new Rete.Output("out1", "[A...A`]", ArraySocket);
    var out2 = new Rete.Output("out2", "Index", NumberSocket);
    var out3 = new Rete.Output('timeOut','TriggerTime',DateTimeSocket);


    this.buildNodeData(node);
    this.registerOnRemove();


    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addInput(inp4)
      .addOutput(out1)
      .addOutput(out2)
      .addOutput(out3);
  }


  doResetNode(resetCount,node) {
    if (node == "all") {
      for (const key in this._nodeStateData) {
        if (this._nodeStateData.hasOwnProperty(key)) {
          const element = this._nodeStateData[key];
          element.reset(resetCount);
        }
      }
    } else {
      this._nodeStateData[node.id].reset(resetCount);
    }
  }
  resetNode(in3, node){

    if(node.inputs["resetIn"].connections[0] != null)
          if(in3 !== null && in3 !== undefined )this.doResetNode(true,node);
  }
  worker(node, inputs, outputs) {
  
        this.resetNode(inputs["resetIn"][0], node);

    let in1 = inputs["in1"][0];
    let in2 = inputs["in2"][0];
    let in3 =  inputs["in3"][0];
    if( this._nodeStateData[node.id].ASet == null){
        if(in1 !== undefined){
          this._nodeStateData[node.id].ASet = [in1];
        }
        return;
    }
else{
  if(in1 !== undefined){
    this._nodeStateData[node.id].ASet.push(in1);
  }
}

    if( this._nodeStateData[node.id].ASet != null && this._nodeStateData[node.id].BSet == null){
        if(in2 !== undefined){
          this._nodeStateData[node.id].BSet = in2;
        }
    }



    if(this._nodeStateData[node.id].ASet != null && this._nodeStateData[node.id].BSet != null){
        if(this._nodeStateData[node.id].lastReset == null){
            var nowMs = new Date();
            nowMs = nowMs.getTime();
            this._nodeStateData[node.id].lastReset = nowMs;
        }
        if(in3 == undefined || Number.isNaN(in3) || this._nodeStateData[node.id].ASet.length >= +in3 ){
          outputs["out1"] = this._nodeStateData[node.id].ASet; 
          outputs["timeOut"] =this._nodeStateData[node.id].lastReset; 
          outputs["out2"] = this._nodeStateData[node.id].count++;
        } 

        this.doResetNode(false,node);
    }
  }
}
